import {NgModule} from '@angular/core';
import {CommonModule, CurrencyPipe, DatePipe, TitleCasePipe} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FormValidationModule} from "~core/components/form-validation/form-validation.module";
import {FormFieldsModule} from "~shared/components/form-fields/form-fields.module";
import {ButtonsModule} from "~shared/components/buttons/buttons.module";
import {DirectivesModule} from "~shared/directives/directives.module";
import {TablesModule} from "~shared/components/tables/tables.module";
import {CreateTixxSelectComponent} from "~features/tixx-select/components/create-tixx-select/create-tixx-select.component";
import {LotteryPreparationComponent} from "~features/tixx-select/pages/lottery-preparation/lottery-preparation.component";
import {TixxSelectComponent} from "~features/tixx-select/pages/tixx-select.component";
import {routing} from "../../app.routing";
import {PipesModule} from "~shared/pipes/pipes.module";
import {WorkspaceFormModule} from "~shared/components/workspace-form/workspace-form.module";
import {TooltipModule} from "~shared/components/tooltip/tooltip.module";
import {NgSelectModule} from "@ng-select/ng-select";
import {ModalModule} from "~shared/components/elements/modal.module";
import {PrimaryRequestsComponent} from "~features/tixx-select/components/lottery-dashboard/primary-requests/primary-requests.component";
import {ExecutionIterationListComponent} from "~features/tixx-select/components/lottery-dashboard/execution-iteration-list/execution-iteration-list.component";
import {EventCategoriesListComponent} from "~features/tixx-select/components/lottery-dashboard/event-categories-list/event-categories-list.component";
import {LotteryDashboardComponent} from "~features/tixx-select/pages/lottery-dashboard/lottery-dashboard.component";
import {FilterRequestsComponent} from "~features/tixx-select/components/lottery-execution/filter-requests/filter-requests.component";
import {LotteryResultsComponent} from "~features/tixx-select/components/lottery-execution/lottery-results/lottery-results.component";
import {LotterySettingsComponent} from "~features/tixx-select/components/lottery-execution/lottery-settings/lottery-settings.component";
import {LotteryExecutionComponent} from "~features/tixx-select/pages/lottery-execution/lottery-execution.component";
import {EventAdministrationService} from "~features/tixx-select/event-administration.service";
import {PriceCategoryService} from "~core/services";
import {LotteryDetailsComponent} from "~features/tixx-select/components/event-administration/forms/lottery-details/lottery-details.component";
import {LotteryDetailsInfoComponent} from "~features/tixx-select/components/event-administration/info-tiles/lottery-data-info/lottery-details-info.component";
import {
  ProcessConfigurationInfoComponent
} from "~features/tixx-select/components/event-administration/info-tiles/process-configuration-info/process-configuration-info.component";
import {ProcessConfigurationComponent} from "~features/tixx-select/components/event-administration/forms/process-configuration/process-configuration.component";
import {
  WebpageIndividualizationInfoComponent
} from "~features/tixx-select/components/event-administration/info-tiles/webpage-individualization-info/webpage-individualization-info.component";
import {
  WebpageIndividualizationComponent
} from "~features/tixx-select/components/event-administration/forms/webpage-individualization/webpage-individualization.component";
import {
  PriceCategoriesListComponent
} from "~features/tixx-select/components/event-administration/info-tiles/price-categories-list/price-categories-list.component";
import {PriceCategoryCreateComponent} from "~features/tixx-select/components/event-administration/forms/price-category/create/price-category-create.component";
import {PriceCategoryEditComponent} from "~features/tixx-select/components/event-administration/forms/price-category/edit/price-category-edit.component";
import {
  PriceReductionsListComponent
} from "~features/tixx-select/components/event-administration/info-tiles/price-reductions-list/price-reductions-list.component";
import {PriceReductionEditComponent} from "~features/tixx-select/components/event-administration/forms/price-reduction/edit/price-reduction-edit.component";
import {
  PriceReductionCreateComponent
} from "~features/tixx-select/components/event-administration/forms/price-reduction/create/price-reduction-create.component";
import {PriceReductionComponent} from "~features/tixx-select/components/event-administration/forms/price-reduction/price-reduction.component";
import {TicketQuotaListComponent} from "~features/tixx-select/components/event-administration/info-tiles/ticket-quota-list/ticket-quota-list.component";
import {TicketQuotaComponent} from "~features/tixx-select/components/event-administration/forms/ticket-quota/ticket-quota.component";
import {
  AssignedReductionsComponent
} from "~features/tixx-select/components/event-administration/forms/price-category/assigned-reductions/assigned-reductions.component";
import {
  OptionalCheckboxInfoComponent
} from "~features/tixx-select/components/event-administration/info-tiles/optional-checkbox-info/optional-checkbox-info.component";
import {OptionalCheckboxComponent} from "~features/tixx-select/components/event-administration/forms/optional-checkbox/optional-checkbox.component";
import {EventAdministrationComponent} from "~features/tixx-select/pages/event-administration/event-administration.component";

/**
 * Module for customer overview section
 */
@NgModule({
  declarations: [
    TixxSelectComponent,
    CreateTixxSelectComponent,
    EventCategoriesListComponent,
    ExecutionIterationListComponent,
    PrimaryRequestsComponent,
    LotteryDashboardComponent,
    FilterRequestsComponent,
    LotteryResultsComponent,
    LotterySettingsComponent,
    LotteryExecutionComponent,
    LotteryPreparationComponent,
    LotteryDetailsComponent,
    LotteryDetailsInfoComponent,
    ProcessConfigurationInfoComponent,
    ProcessConfigurationComponent,
    WebpageIndividualizationInfoComponent,
    WebpageIndividualizationComponent,
    PriceCategoriesListComponent,
    PriceCategoryCreateComponent,
    PriceCategoryEditComponent,
    PriceReductionsListComponent,
    PriceReductionEditComponent,
    PriceReductionCreateComponent,
    PriceReductionComponent,
    TicketQuotaListComponent,
    TicketQuotaComponent,
    AssignedReductionsComponent,
    OptionalCheckboxInfoComponent,
    OptionalCheckboxComponent,
    EventAdministrationComponent
  ],
  exports: [
    TixxSelectComponent,
    CreateTixxSelectComponent,
    EventCategoriesListComponent,
    ExecutionIterationListComponent,
    PrimaryRequestsComponent,
    LotteryDashboardComponent,
    FilterRequestsComponent,
    LotteryResultsComponent,
    LotterySettingsComponent,
    LotteryExecutionComponent,
    LotteryPreparationComponent,
    LotteryDetailsComponent,
    LotteryDetailsInfoComponent,
    ProcessConfigurationInfoComponent,
    ProcessConfigurationComponent,
    WebpageIndividualizationInfoComponent,
    WebpageIndividualizationComponent,
    PriceCategoriesListComponent,
    PriceCategoryCreateComponent,
    PriceCategoryEditComponent,
    PriceReductionsListComponent,
    PriceReductionEditComponent,
    PriceReductionCreateComponent,
    PriceReductionComponent,
    TicketQuotaListComponent,
    TicketQuotaComponent,
    AssignedReductionsComponent,
    OptionalCheckboxInfoComponent,
    OptionalCheckboxComponent,
    EventAdministrationComponent
  ],
  providers: [
    EventAdministrationService,
    PriceCategoryService,
    DatePipe,
    TitleCasePipe,
    CurrencyPipe,
  ],
  imports: [
    CommonModule,
    routing,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule,
    FormValidationModule,
    FormFieldsModule,
    ButtonsModule,
    TablesModule,
    WorkspaceFormModule,
    TooltipModule,
    NgSelectModule,
    ModalModule
  ]
})
export class TixxSelectModule {
}
